import { Routes, Route, Navigate } from "react-router-dom";
import {
  Main,
  Write,
  Post,
  Login,
  SlideBoard,
  PostList,
  UserManagePage,
  BoardManagePage,
  SearchPage,
  // Landing, // 이전 랜딩 디자인 (롤백용)
  LandingRenewal,
  Conference,
  Mission,
  Publication,
  Committee,
  QnA,
  Reference,
  CategoryManagePage,
  Signup,
  SignupManagePage,
  Tribute,
  DedicatedBoard,
  Encouragement,
  MyPage,
  ErrorReport,
  Gallery,
  GalleryMosaic,
  GalleryStrip,
  // 갤러리 디자인 시안 — 시안 A 채택으로 라우트 숨김 (코드는 page/GalleryDraft*.tsx 에 유지)
  // GalleryDraftCover,
  // GalleryDraftMosaic,
  // GalleryDraftShelf,
} from "../page";
import SlideFileCheckPage from "../page/admin/SlideFileCheckPage";
import CategoryDndEditorPage from "../page/admin/CategoryDndEditorPage";
import PermissionManagePage from "../page/admin/PermissionManagePage";
import BoardCategoryPermissionPage from "../page/admin/BoardCategoryPermissionPage";
import { AdminLayout } from "../component/admin";
import Category from "../page/Category";
import ConsultPostPage from "../page/ConsultPostPage";
import Viewer from "../page/Viewer";
import DemoViewer from "../page/DemoViewer";
import DemoConsultation from "../page/DemoConsultation";
import TempLinkEntry from "../page/TempLinkEntry";
import PartnerEntry from "../page/PartnerEntry";

export const AppRoutes = () => {
  return (
    <Routes>
      {/* 이전 랜딩 디자인 (롤백용) */}
      {/* <Route path="/" element={<Landing />} /> */}
      <Route path="/" element={<LandingRenewal />} />
      <Route path="/gallery" element={<Main />} />
      <Route path="/write" element={<Write />} />
      <Route path="/post" element={<Post />}>
        <Route path=":id" element={<Post />} />
      </Route>
      {/* 자문 게시글 페이지 (좌 에디터 / 중앙 뷰어 / 우 정보·자문) */}
      <Route path="/consult-post/:id" element={<ConsultPostPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/viewer/:id" element={<Viewer />} />
      <Route path="/demo/viewer/:id" element={<DemoViewer />} />
      <Route path="/demo/consultation/:boardId" element={<DemoConsultation />} />
      <Route path="/temp-link/:uuid" element={<TempLinkEntry />} />
      <Route path="/partner-entry" element={<PartnerEntry />} />
      {/* <Route path="/category" element={<CategoryList />} /> */}
      <Route path="/login" element={<Login />} />
      <Route path="/slideboard/:boardId" element={<SlideBoard />} />
      {/* <Route path="/post-list/:categoryId" element={<PostList />} /> */}
      <Route path="/post-list/:categoryId" element={<GalleryMosaic />} />
      {/* <Route path="/consultation/:boardId" element={<Consultation />} /> // 마이그레이션 버전 (클라이언트가 구버전으로 교체 요청) */}
      {/* <Route path="/consultation/:boardId" element={<ConsultationV2 />} /> */}
      <Route path="/portal" element={<Category />} />
      <Route path="/conference" element={<Conference />} />
      <Route path="/mission" element={<Mission />} />
      <Route path="/publication" element={<Publication />} />
      <Route path="/tribute" element={<Tribute />} />
      <Route path="/committee" element={<Committee />} />
      <Route path="/qna" element={<QnA />} />
      <Route path="/reference" element={<Reference />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dedicated" element={<DedicatedBoard />} />
      <Route path="/encouragement" element={<Encouragement />} />
      <Route path="/mypage" element={<MyPage />} />
      {/* <Route path="/report" element={<ErrorReport />} /> */}
      <Route path="/gallery-new/:categoryId" element={<Gallery />} />
      <Route path="/gallery-mosaic/:categoryId" element={<GalleryMosaic />} />
      <Route path="/gallery-strip/:categoryId" element={<GalleryStrip />} />

      {/* /gallery 신규 디자인 시안 — 시안 A 를 /gallery 에 채택하여 숨김 (다시 비교하려면 주석 해제) */}
      {/* <Route path="/gallery-draft/cover" element={<GalleryDraftCover />} />
      <Route path="/gallery-draft/mosaic" element={<GalleryDraftMosaic />} />
      <Route path="/gallery-draft/shelf" element={<GalleryDraftShelf />} /> */}

      {/* For Admin */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route path="users" element={<UserManagePage />} />
        <Route path="permissions" element={<PermissionManagePage />} />
        <Route path="board-category-permissions" element={<BoardCategoryPermissionPage />} />
        <Route path="signup" element={<SignupManagePage />} />
        <Route path="boards" element={<BoardManagePage />} />
        <Route path="category" element={<CategoryManagePage />} />
        <Route path="category-editor" element={<CategoryDndEditorPage />} />
        <Route path="file-check" element={<SlideFileCheckPage />} />
      </Route>
    </Routes>
  );
};
